import { render, staticRenderFns } from "./PromotionBanner.vue?vue&type=template&id=fe07ce9e&scoped=true&"
import script from "./PromotionBanner.vue?vue&type=script&lang=js&"
export * from "./PromotionBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe07ce9e",
  null
  
)

export default component.exports